module.exports = __webpack_public_path__ + "img/icon-wa.52d69517.png";